import { FC, SVGProps } from 'react';

export const CalendarIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none' {...props}>
		<path
			d='M7.5 6.09375C7.24375 6.09375 7.03125 5.88125 7.03125 5.625V3.75C7.03125 3.49375 7.24375 3.28125 7.5 3.28125C7.75625 3.28125 7.96875 3.49375 7.96875 3.75V5.625C7.96875 5.88125 7.75625 6.09375 7.5 6.09375Z'
			fill='currentColor'
		/>
		<path
			d='M12.5 6.09375C12.2438 6.09375 12.0312 5.88125 12.0312 5.625V3.75C12.0312 3.49375 12.2438 3.28125 12.5 3.28125C12.7562 3.28125 12.9688 3.49375 12.9688 3.75V5.625C12.9688 5.88125 12.7562 6.09375 12.5 6.09375Z'
			fill='currentColor'
		/>
		<path
			d='M11.875 16.7188H8.125C4.6125 16.7188 3.90625 15.0625 3.90625 12.3875V8.53125C3.90625 5.56875 4.90625 4.3625 7.475 4.21875H12.5C12.5062 4.21875 12.5188 4.21875 12.525 4.21875C15.0938 4.3625 16.0938 5.56875 16.0938 8.53125V12.3875C16.0938 15.0625 15.3875 16.7188 11.875 16.7188ZM7.5 5.15625C5.75 5.25625 4.84375 5.80625 4.84375 8.53125V12.3875C4.84375 14.7812 5.3 15.7812 8.125 15.7812H11.875C14.7 15.7812 15.1562 14.7812 15.1562 12.3875V8.53125C15.1562 5.8125 14.2562 5.25625 12.4875 5.15625H7.5Z'
			fill='currentColor'
		/>
		<path
			d='M15.4688 13.9688H4.53125C4.275 13.9688 4.0625 13.7562 4.0625 13.5C4.0625 13.2438 4.275 13.0312 4.53125 13.0312H15.4688C15.725 13.0312 15.9375 13.2438 15.9375 13.5C15.9375 13.7562 15.725 13.9688 15.4688 13.9688Z'
			fill='currentColor'
		/>
	</svg>
);
